import { allExtensionsFile, LOADING } from './constants';

export const splitFileName = (fileName) => {
  const idxDot = fileName.lastIndexOf('.');
  const nameFile = fileName.substring(0, idxDot);
  const extFile = fileName.substring(idxDot + 1).toLowerCase();

  return { nameFile, extFile };
};

export const prepareFiles = (files, isAttachments) => [...files].reduce((newFiles, currentFile) => {
  const { nameFile, extFile } = splitFileName(currentFile.name);

  if (allExtensionsFile.includes(extFile) && ((isAttachments && !nameFile.includes('%')) || !isAttachments)) {
    return newFiles.concat({
      fullName: currentFile.name,
      name: nameFile,
      type: extFile,
      size: currentFile.size,
      status: LOADING,
    });
  }

  return newFiles;
}, []);

export const removePercentageFromName = (files) => {
  const updatedFiles = new DataTransfer();

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const updatedFile = new File([file], file.name.replace('%', '_'), {
      type: file.type,
      lastModified: file.lastModified,
    });
    updatedFiles.items.add(updatedFile);
  }

  return updatedFiles.files;
};
